/*
 * Copyright (c) Siemens Energy AG 2020 ALL RIGHTS RESERVED
 * I&C Monitors and Advisors (ICMA)
 */

import React, { Component } from 'react';
import classes from './Popup.module.css';
import Backdrop from '../../Ui/Backdrop/Backdrop';
import Button from '../../Ui/LoadingButtonComponent/Button';

class Popup extends Component {
  constructor(props) {
    super(props);
  }
  checkDownload(fileNameList) {
    this.props.checkDownload(fileNameList);
  }
  render() {
    let classNameTr = classes['dls-rp-popupInner'];
    if (this.props.unitName) {
      classNameTr = classes['dls-rp-popupInnerU'];
    } else {
      classNameTr = classes['dls-rp-popupInner'];
    }
    return (
      <>
        <div className={`${classes['dls-rp-popup']}`}>
          <div className={classNameTr}>
            <div className={`${classes['dls-rp-popupHeader']}`}>
              <strong>Download {this.props.text} Report</strong>
            </div>
            <div className={`${classes['dls-rp-popupContent']}`}>
              {this.props.fileNameList.length <= 15 ? (
                <table>
                  <tbody>
                    <tr>
                      <td>Plant:</td>
                      <td>{' ' + this.props.plantName}</td>
                    </tr>
                    {this.props.unitName ? (
                      <tr>
                        <td>Unit:</td>
                        <td>{' ' + this.props.unitName}</td>
                      </tr>
                    ) : null}

                    <tr>
                      <td>File:</td>
                      <td>
                        {this.props.fileNameList.map((fileName, index) => (
                          <li key={index}>{fileName}</li>
                        ))}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <div>
                  {`Max number of files can be downloaded is 15, currently selected ${this.props.fileNameList.length}`}
                </div>
              )}
            </div>
            <div className={`${classes['dls-rp-popupButtonWrapper']}`}>
              <div className={`${classes['dls-rp-popupButtons']}`}>
                {this.props.fileNameList.length <= 15 ? (
                  <Button
                    className={`${classes['dls-rp-download']}`}
                    onClick={this.checkDownload.bind(
                      this,
                      this.props.fileNameList
                    )}
                    loadingText="Downloading"
                    loading={this.props.isLoading}
                  >
                    Download
                  </Button>
                ) : null}
                &nbsp;
                <button
                  className={`${classes[' dls-rp-cancel']}`}
                  onClick={this.props.closePopup}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
        )
        <Backdrop show={true} clicked={this.props.close} />
      </>
    );
  }
}
export default Popup;
